var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherPartlyCloudy1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0425 4.6084H9.64253V8.1084H11.0425V4.6084Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49003 15.8084C6.20136 14.2781 6.39724 11.9929 7.92753 10.7042C9.45782 9.41557 11.743 9.61144 13.0317 11.1417L11.9584 12.0576C11.4185 11.4149 10.562 11.1323 9.74577 11.3274C8.92949 11.5226 8.29341 12.162 8.10253 12.9792C7.94421 13.6595 8.11489 14.3746 8.56336 14.9101L7.49003 15.8084Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 23.3917H22.3767C24.491 23.3917 26.206 21.6794 26.2092 19.5651V19.3609C26.2064 17.2704 24.5311 15.5665 22.4409 15.5284C21.8832 13.1803 19.7966 11.5149 17.3834 11.4917H16.6659C14.2526 11.5149 12.166 13.1803 11.6084 15.5284C9.51816 15.5665 7.84286 17.2704 7.84003 19.3609V19.5651C7.84003 20.58 8.24319 21.5533 8.96083 22.2709C9.67847 22.9886 10.6518 23.3917 11.6667 23.3917ZM9.24003 19.3492C9.24003 18.0081 10.3255 16.9199 11.6667 16.9167H12.8334L12.9034 16.2984C13.1134 14.3713 14.7333 12.907 16.6717 12.8917H17.3834C19.3156 12.9092 20.9306 14.3665 21.1459 16.2867L21.21 16.9167H22.3767C23.0239 16.9167 23.6444 17.1746 24.1009 17.6333C24.5574 18.092 24.8123 18.7137 24.8092 19.3609V19.5651C24.806 20.9062 23.7179 21.9917 22.3767 21.9917H11.6667C11.0216 21.9902 10.4035 21.7324 9.94837 21.2751C9.49328 20.8179 9.23848 20.1985 9.24003 19.5534V19.3492Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66202 7.67113L4.6518 6.681L7.1271 9.15544L6.13733 10.1456L3.66202 7.67113Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09253 12.6584H1.59253V14.0584H5.09253V12.6584Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66162 19.0565L6.13649 16.5816L7.12644 17.5715L4.65157 20.0464L3.66162 19.0565Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0357 6.67463L13.5608 9.1495L14.5507 10.1395L17.0256 7.66458L16.0357 6.67463Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherPartlyCloudy1);
export default __webpack_public_path__ + "static/media/weather-partly-cloudy-1.46c7ba0129dd237dda2a9dd623a0e392.svg";
export { ForwardRef as ReactComponent };